<!-- 一周任务趋势图表 -->
<template>
	<el-row :gutter="12" style="margin-top: 10px;">
		<el-col :span="24">
			<v-chart class="chart" :option="option" />
		</el-col>
	</el-row>
</template>

<script>
	// 图表 - 开始
	import {
		use
	} from "echarts/core";
	import {
		CanvasRenderer
	} from "echarts/renderers";
	import {
		LineChart
	} from "echarts/charts";
	import {
		GridComponent,
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		ToolboxComponent
	} from "echarts/components";
	import VChart, {
		THEME_KEY
	} from "vue-echarts";

	use([
		CanvasRenderer,
		LineChart,
		GridComponent,
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		ToolboxComponent
	]);
	// 图表 - 结束
	export default {
		name: 'weekEcharts',
		components: {
			VChart
		},
		provide: {
			// [THEME_KEY]: "dark"
		},
		props: { // 定义组件的属性
			xAxis_data: {
				type: Array,
				default: [],
			},
			y_one: {
				type: Array,
				default: [],
			},
			y_two: {
				type: Array,
				default: [],
			},
		},
		watch:{
			xAxis_data(){
				this.option.xAxis.data = this.xAxis_data;
			},
			y_one(){
				this.option.series[0].data = this.y_one;
			},
			y_two(){
				this.option.series[1].data = this.y_two;
			}
		},
		data() {
			return {
				option: {
					title: {
						text: '一周任务趋势',
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['发布量', '接单量']
					},
					toolbox: {
						feature: {
							saveAsImage: {
								'title':'保存为图片'
							}
						},
						right:'20px',
					},
					xAxis: {
						type: 'category',
						data: []
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '发布量',
						type: 'line',
						data: [],
						label: { // 显示每个点的数字 series.emphasis.label.show
							show: true,
							position: 'top',
						},
					}, {
						name: '接单量',
						type: 'line',
						data: [],
						label: { // 显示每个点的数字 series.emphasis.label.show
							show: true,
							position: 'top',
						},
					}, ]

				},
			}
		},
		methods: {

		}
	}
</script>
<style scoped>
	.chart {
		height: 300px;
	}
</style>
